<template>
  <div id="addStore">
    <div class="top clearfix">
      <i class="el-icon-menu"></i>
      <div class="msgTitle">商品信息</div>
      <div class="button">
        <el-button
          class="excelBtn"
          type="danger"
          icon="el-icon-delete"
          :disabled="del"
          @click="deleteGoods"
        >删除商品</el-button>
        <el-button class="excelBtn" type="primary" icon="el-icon-plus" @click="editGoods">确认修改</el-button>
      </div>
    </div>
    <div class="containertMain">
      <div class="container1">
        <el-form ref="form" label-width="100px">
          <div class="Modular1">
            <div class="title">基本信息</div>
            <div class="content">
              <el-row>
                <el-form-item label="*商品主图" class="upload">
                  <ul class="imagesList">
                    <li class="imagesItem" v-for="(item, index) in imagesList" :key="index">
                      <img class="img" :src="item" alt width="100%" height="100%" />
                      <img
                        class="del"
                        src="../assets/images/fail.png"
                        alt
                        @click="delImages(index)"
                      />
                    </li>
                  </ul>
                  <div @click="handleUploadImages(1)" class="picture">
                    <img src="../assets/images/addImages.png" alt width="100%" height="100%" />
                  </div>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*商品名称">
                    <el-input placeholder="请输入商品名称" class="inputItem" v-model="goodsName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="*商品分类">
                    <!-- <el-input placeholder="上架" class="inputItem" v-model="status"></el-input> -->
                    <el-select
                      class="inputItem"
                      v-model="type"
                      placeholder="请选择"
                      @change="changeStatu($event)"
                    >
                      <el-option
                        v-for="item in goodsCategory"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="商品促销语">
                    <el-input
                      class="inputItem"
                      v-model="saleDesc"
                      placeholder="请输入，最多100字符"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="原价(元)">
                    <el-input
                      class="inputItem"
                      v-model="oldPrice"
                      placeholder="请输入商品价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                    <div class="textColor">原价仅作为价格对比展示，不按此价格进行销售</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="*成本">
                    <el-input
                      placeholder="请输入，最大999,999,999"
                      class="inputItem"
                      v-model="costPrice"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                    <div class="textColor">不展示在商城内，尽量填写完整，有助于商品销售的数据分析</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*销售价(元)">
                    <el-input
                      class="inputItem"
                      v-model="price"
                      placeholder="请输入商品价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="园区币价">
                    <el-input
                      class="inputItem"
                      v-model="gardenPrice"
                      placeholder="请输入园区币价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*商品库存">
                    <el-input
                      placeholder="请输入"
                      class="inputItem"
                      v-model="stacks"
                      maxlength="11"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="*预警库存">
                    <el-input
                      placeholder="请输入,库存不足进行提醒"
                      class="inputItem"
                      v-model="warningRepertory"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="商品类型">
                    <el-checkbox-group v-model="checkType" class="check">
                      <el-checkbox
                        v-for="(item,index) in checkTypeList"
                        :label="item.id"
                        :key="index"
                        @change="handleCheckedTypesChange(item.id)"
                      >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="商品条形码">
                    <el-input
                      class="inputItem"
                      v-model="barCode"
                      placeholder="请输入商品条形码"
                      oninput="value=value.replace(/[^\d]/g,'')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="Modular1">
            <div class="title">设置</div>
            <div class="content">
              <el-row>
                <el-col :span="12">
                  <!-- <el-form-item class='check'> -->
                  <el-checkbox-group v-model="checkList" class="check">
                    <el-checkbox
                      v-for="(item,index) in checkBoxList"
                      :label="item.id"
                      :key="index"
                      :disabled="preSaleStatus == 1 "
                      @change="handleCheckedCitiesChange(item.id)"
                    >{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                  <!-- </el-form-item> -->
                </el-col>
              </el-row>
              <div class="presellSet" v-show="status === -1">
                <div class="set">预售设置(预售为全款预售，预售商品不支持加入购物车)</div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售价格(元)">
                      <el-input
                        class="inputItem"
                        v-model="presalePrice"
                        placeholder="请输入，最大999,999,999"
                        maxlength="100"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售说明">
                      <el-input class="inputItem" v-model="mark" placeholder="最多30字" maxlength="30"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售结束时间">
                      <el-date-picker
                        class="endDate inputItem"
                        v-model="etime"
                        type="datetime"
                        :picker-options="expireTimeOption"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="num">预售结束后，商品下架</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="已预定量">
                      <div class="endNum">
                        当预售结束后，已预定量少于
                        <el-input
                          placeholder="请输入，最大999"
                          class="inputItem30"
                          v-model="minCount"
                          oninput="value=value.replace(/[^\d]/g,'')"
                          maxlength="11"
                        ></el-input>进行提醒
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发货时间">
                      <el-radio-group v-model="preRedio" @change="changeRedio">
                        <el-radio class="blex1" label="0">
                          <el-select
                            v-model="sendType"
                            placeholder="请选择"
                            :disabled="preRedio!=='0'"
                          >
                            <el-option
                              v-for="item in dateOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <el-input
                            placeholder="请输入，最大999"
                            class="inputItem30"
                            v-model="date1"
                            :disabled="preRedio!=='0'"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                          ></el-input>天之内
                        </el-radio>
                        <el-radio class="blex2" label="1">
                          <el-date-picker
                            class="startDate"
                            v-model="date2"
                            type="date"
                            :picker-options="expireTimeOption"
                            :disabled="preRedio=='0'"
                            placeholder="选择日期"
                          ></el-date-picker>开始发货
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="Modular1" v-if="status == 0 || status == 1">
            <div class="title">
              商品关联
              <span class="title_">商品关联成功后，可在商城内的本商品详情内快速查看或购买其关联商品。商品属性用于区分各关联商品。</span>
            </div>
            <div class="content">
              <div class="shuxing">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="本商品属性" :required="true">
                      <el-input v-model="propertyName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-for="(item,index) in relatedGoods" :key="index">
                  <el-col :span="11">
                    <el-form-item label="属性" :required="true">
                      <el-input v-model="item.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="关联商品" :required="true">
                      <el-input v-model="item.goodName">
                        <el-button slot="append" @click="selectProducts(index)">选择商品</el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-button
                      type="text"
                      style="width:80%;margin-left:20%;color:red;"
                      @click="delRelated(index)"
                    >删除</el-button>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-button type="primary" @click="addRelated" style="width:150px;">添加</el-button>
                  <el-button
                    type="primary"
                    style="width:150px;"
                    @click="dialogVisible = true"
                  >新增商品并关联</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="Modular2">
            <div class="title">商品介绍</div>
            <div class="content">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="规格">
                    <el-input placeholder="例如：一箱" v-model="specification"></el-input>
                  </el-form-item>
                </el-col>
                <!--  -->
                <el-col :span="12">
                  <el-form-item label="重量">
                    <el-input placeholder="不限" class="inputItem" v-model="weight"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="保质期">
                    <el-input placeholder="请输入保质期" class="inputItem" v-model="liftTime"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产地">
                    <el-input
                      placeholder="最长8个字符"
                      maxlength="8"
                      class="inputItem"
                      v-model="product"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item label="限购(件)">
                    <el-input placeholder="不限" class="inputItem" v-model="limit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="商品溯源">
                    <el-select @change="changezhou($event)" class="inputItem" v-model="suyuan" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <div style="color:#1591CF;cursor:pointer" @click="go">编辑溯源信息</div>
                  </el-form-item>
                </el-col>
              </el-row>-->
              <el-row>
                <el-form-item label="商品描述">
                  <div style="text-align:left">
                    <div ref="toolbar" class="toolbar">
                      <div
                        class="el-icon-picture w-e-icon-image uploadimg"
                        @click="handleUploadImages(2)"
                      ></div>
                    </div>
                    <div ref="editor" class="editor"></div>
                  </div>
                </el-form-item>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog title="选择商品" :visible.sync="centerDialogVisible" width="60%" center>
      <div style="margin:20px 0;">
        <el-input
          style="width:300px;"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="goodName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="price" label="售价" width="180"></el-table-column>
        <el-table-column align="center" prop="stock" label="库存" width="180"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageFn()"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增商品并关联" :visible.sync="dialogVisible" width="80%" center>
      <v-addgood @func="getValue" :msgval="msg"></v-addgood>
    </el-dialog>
  </div>
</template>
<script>
import {
  tradeGoods,
  putGoods,
  getUploadId,
  getUploadToken,
  getgoodsclassification,
  getgoodInfo,
  exitGoods,
  getGoodCategory,
  getSeckillGood,
  exitPreGoods,
} from "@/api/goods";
import E from "wangeditor";
import vAddgood from "./addGood.vue";
import A from "../assets/upload";
import { mapGetters, mapActions } from "vuex";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];
export default {
  mixins: [A],
  components: {
    vAddgood,
  },
  data() {
    const _this = this;
    return {
      dialogImageUrl: "",
      Image: "",
      category: "全部",
      classList: "",
      statusBox: [
        {
          value: 0,
          label: "在售",
        },
        {
          value: 1,
          label: "下架",
        },
        {
          value: 2,
          label: "删除",
        },
      ],
      stacks: "",
      dialogVisible: false,
      fileList: [],
      goodsName: "",
      goodId: "",
      price: "",
      specification: "",
      classify: "",
      status: "",
      stockType: "",
      statusId: "",
      impose: "",
      content: "",
      product: "",
      limit: "",
      gardenPrice: "",
      trace: "",
      options: [
        {
          value: 1,
          label: "开启",
        },
        {
          value: 0,
          label: "关闭",
        },
      ],
      suyuan: "",
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // (handleUploadImage() {
                  let option = {
                    multiple: !1,
                    params: {
                      isupdate: 2,
                      region: "ap-beijing",
                      bucket: "range-smartpark-1257239906",
                      previewUrl:
                        "https://cdn.shop.rangepark.cn/2492635422220354557.png ",
                    },
                    getFileId: getUploadId,
                    getAuthFunction: getUploadToken,
                    accept: "image/*",
                  };
                  _this.handleClickUpload(option);
                  // })();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      imagesList: [], // 完成上传图片展示列表
      type: "", // 商品类型
      categoryId: "", // 商品分类Id
      goodsTypeList: [
        // 商品类型列表
        {
          value: "0",
          label: "园区配送",
        },
        {
          value: "1",
          label: "快递邮寄",
        },
        {
          value: "2",
          label: "到点自取",
        },
      ],
      goodsCategory: [], // 商品分类列表
      promotion: "", // 促销语
      oldPrice: "", // 原价
      weight: "", // 重量
      saleDesc: "", // 促销语
      liftTime: "", // 保质期
      newImagesList: [],
      goodId: "", // 商品ID
      barCode: "", // 条形码
      del: false,
      warningRepertory: "", //预警库存
      checkList: [], // 选择设置类型
      // 预售参数
      costPrice: "", //成本价
      endTime: "", // 预售结束时间
      presalePrice: "", //预售价格
      presaleMark: "", //预售说明
      minCount: "", // 最小预售量
      sendType: this.sendType, //发货类型
      sendTime: this.preRedio == "0" ? this.date1 : this.date2, //发货时间
      date1: "",
      date2: "",
      checkBoxList: [
        { id: 0, name: "正常销售" },
        { id: -1, name: "商品预售" },
        { id: 1, name: "不上架" },
      ],
      preRedio: "0",
      dateOptions: [
        {
          value: 1,
          label: "预售结束",
        },
        {
          value: 2,
          label: "支付成功",
        },
      ],
      // 预售
      etime: "",
      minCount: "",
      mark: "",
      presalePrice: 0,
      sendTime: "",
      sendType: "",
      preSaleStatus: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        },
      },
      checkTypeList: [
        { id: 2, name: "到店自取" },
        { id: 1, name: "园区配送" },
      ],
      checkType: [],
      selectType: 1,
      relatedGoods: [], //关联商品列表
      searchValue: "", //添加关联商品列表搜索字段
      tableData: [], //添加关联商品列表
      centerDialogVisible: false,
      currentPage: 1,
      goodsCount: 10,
      selectIndex: 0,
      propertyName: "",
      dialogVisible: false,
      msg:true,
    };
  },
  created() {
    this.getClass();
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.info_ = null;
      }
    },
    content(value) {
      if (value !== this.editor.txt.html()) {
        // console.log(value);
        this.editor.txt.html(value);
        // console.log(this.editor.txt.html(value));
      }
    },
    imagesList(val) {
      let newArr = [];
      if (!val.length) {
        newArr = val;
        return newArr;
      } else {
        this.newImagesList.forEach((item) => {
          newArr.push(item.src);
        });
        newArr = val.concat(newArr);
        return newArr;
      }
    },
    // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.$on("upload-finish", (data) => {
      let { isupdate, sort } = data;
      if (!data) return;
      if (isupdate == 2) {
        this.editor.cmd.do(
          // 'insertImage',
          //  data.src
          "insertHtml",
          '<img src="' + data.src + '" style="max-width:100%;"/>'
        );
      } else {
        if (this.imagesList.length > 4) {
          this.$message("最多上传5张图");
          return;
        }
        this.imagesList.push(data.src);
        this.imagesList = this.order2(this.imagesList);
        // console.log('imagesList', this.imagesList);
      }
    });
    this._getGoodsCategory();
    this.seteditor();
    let id = this.$route.query.id;
    this.editType = this.$route.query.editType;
    // console.log(this.checkList);
    if (!id) {
      this.goodId = localStorage.getItem("goodId");
      this.status = localStorage.getItem("mp_status");
      this.preSaleStatus = localStorage.getItem("mp_preSaleStatus");
      if (this.status !== "") {
        this.checkList.push(Number(this.status));
      }
    } else {
      localStorage.setItem("goodId", this.$route.query.id);
      localStorage.setItem("mp_status", this.$route.query.status);
      localStorage.setItem("mp_preSaleStatus", this.$route.query.preSaleStatus);
      this.preSaleStatus = this.$route.query.preSaleStatus;
      let status = this.$route.query.status;
      this.checkList = [];
      this.checkList.push(status);
    }
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  methods: {
    seteditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      // 配置菜单
      this.editor.customConfig.menus = [
        "bold", // 粗体
        // 'fontSize', // 字号
        "justify", // 对齐方式
        // 'fontName', // 字体
        "emoticon", // 表情
      ];
      this.editor.customConfig.showLinkImg = false;
      this.editor.customConfig.onchange = (html) => {
        let newStr = this.getImageFileId(html);
        let newWords = this.order(newStr);
        this.content = newWords;
        // console.log(this.content);
      };
      // 创建富文本编辑器
      this.editor.create();
    },
    handleUploadImages(index) {
      if (index == 1) {
        if (this.imagesList.length >= 5) {
          this.$message("最多上传5张图");
          return;
        }
      }
      let option = {
        multiple: !0,
        params: {
          isupdate: index,
          region: "ap-beijing",
          bucket: "range-smartpark-1257239906",
          previewUrl: "https://cdn.shop.rangepark.cn",
        },
        getFileId: getUploadId,
        getAuthFunction: getUploadToken,
        accept: "image/*",
      };
      this.handleClickUpload(option);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    deleteGoods() {
      this.del = true;
      let data = {
        goodId: localStorage.getItem("goodId"),
        status: "2",
      };
      console.log(data);
      putGoods(data)
        .then((res) => {
          if (res.data == "SUCCESS") {
            this.del = false;
            this.$message({
              type: "info",
              message: "删除成功",
            });
            this.$router.push({
              path: "/main/storeUp",
            });
          } else {
            this.del = false;
          }
        })
        .catch((err) => {
          this.del = false;
        });
    },
    // 获取商品分类
    _getGoodsCategory() {
      getGoodCategory().then((res) => {
        // console.log('Category', res);
        this.goodsCategory = res.data;
      });
    },
    async getClass() {
      let data = {
        shopId: this.chooseCompany.id,
      };
      await getgoodsclassification(data).then((res) => {
        this.classList = res.data;
        // console.log('classList', this.classList);
      });
      await this.getgoodInfoMsg();
    },
    getgoodInfoMsg() {
      let data = {
        goodId: localStorage.getItem("goodId"),
      };
      getgoodInfo(data).then((res) => {
        console.log("data123", res);
        this.Image = res.data.logo;
        this.imagesList = res.data.Logos;
        this.goodsName = res.data.goodName;
        this.type = res.data.type;
        this.weight = res.data.weight;
        this.liftTime = res.data.liftTime;
        this.content = res.data.content;
        this.goodId = res.data.goodId;
        this.barCode = res.data.barCode;
        this.price = this.regFenToYuan(res.data.price)
          ? this.regFenToYuan(res.data.price)
          : 0;
        this.costPrice = this.regFenToYuan(res.data.costPrice)
          ? this.regFenToYuan(res.data.costPrice)
          : 0;
        console.log(this.costPrice);
        this.specification = res.data.unit;
        this.status = Number(res.data.status);
        this.stacks = res.data.mpStock;
        this.warningRepertory = res.data.warningRepertory;
        this.limit = res.data.maxSale;
        this.goodId = res.data.goodId;
        this.oldPrice = this.regFenToYuan(res.data.oldPrice)
          ? this.regFenToYuan(res.data.oldPrice)
          : 0;
        let newDeliveryType = res.data.deliveryType;
        if (newDeliveryType.length > 1) {
          if (newDeliveryType.indexOf(",") > 0) {
            newDeliveryType = res.data.deliveryType.split(",");
          } else {
            newDeliveryType = res.data.deliveryType.split("");
          }
        } else {
          newDeliveryType = res.data.deliveryType.split();
        }
        newDeliveryType.forEach((item) => {
          item = parseInt(item);
          this.checkType.push(item);
        });
        console.log(this.checkType);
        this.saleDesc = res.data.saleDesc;
        this.product = res.data.origin;
        this.gardenPrice = this.regFenToYuan(res.data.employeePrice)
          ? this.regFenToYuan(res.data.employeePrice)
          : 0;
        this.content = res.data.content;
        this.suyuan = Number(res.data.stockType);
        if (res.data.etime) {
          this.etime = this.getDateString(res.data.etime);
        }
        // this.etime = this.getDateString(res.data.etime) || '';
        console.log("etime", this.etime);
        this.minCount = res.data.min_count;
        this.mark = res.data.mark;
        this.presalePrice = this.regFenToYuan(res.data.preselPrice)
          ? this.regFenToYuan(res.data.preselPrice)
          : 0;
        this.sendType = res.data.send_type;
        if (this.sendType === "1" || this.sendType === "2") {
          this.preRedio = "0";
          this.date1 = res.data.send_time;
          this.dateOptions.forEach((item) => {
            if (this.sendType == item.value) {
              this.sendType = item.value;
            }
          });
        } else {
          this.preRedio = "1";
          this.date2 = res.data.send_time;
          this.sendType = "";
        }
        for (let i = 0; i < res.data.linkGoodsList.length; i++) {
          if (res.data.goodId == res.data.linkGoodsList[i].goodId) {
            let data = res.data.linkGoodsList[i];
            this.propertyName = data.name;
          }else{
            let data = {
              name:res.data.linkGoodsList[i].name,
              goodName:res.data.linkGoodsList[i].goodName,
              id:res.data.linkGoodsList[i].goodId
            }
            this.relatedGoods.push(data)
          }
        }
        // }
      });
    },
    changezhou(event) {
      this.stockType = event;
    },
    changeStatu(event) {
      this.type = event;
    },
    //获取图片路径
    getImageSrc() {
      if (!this.imagesList.length) {
        this.$message("上传图片不能为空");
        return;
      } else {
        return this.imagesList;
      }
    },
    concatImages() {
      let newArr = [];
      if (!this.newImagesList.length) {
        newArr = this.imagesList;
        return newArr;
      } else {
        this.newImagesList.forEach((item) => {
          newArr.push(item.src);
        });
        newArr = this.imagesList.concat(newArr);
        return newArr;
      }
    },
    // 提交修改信息
    editGoods() {
      var reContent = this.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        function (match, reSrc) {
          var newImg = '<img src="' + reSrc + '" alt="" style="width:100%;" />';
          return newImg;
        }
      );
      let prices = Math.ceil(this.price * 100);
      let gardenPri = Math.ceil(this.gardenPrice * 100);
      let gardenOldPrice = Math.ceil(this.oldPrice * 100);
      let gardenCostPrice = Math.ceil(this.costPrice * 100);
      console.log(gardenCostPrice);
      let newImages = this.getImageSrc();
      if (!newImages) return;
      if (!this.goodsName) {
        this.$message("商品姓名必不能为空");
        return;
      }
      if (!this.type) {
        this.$message("商品类型不能为空");
        return;
      }
      if (!this.type) {
        this.$message("商品分类不能为空");
        return;
      }
      if (!gardenPri) {
        this.$message("普通价格不能为空或0");
        return;
      }
      if (!this.warningRepertory) {
        this.$message("预警库存不能为空或0");
        return;
      }
      if (!gardenCostPrice) {
        console.log(this.gardenCostPrice);
        this.$message("商品成本价不能为空或0");
        return;
      }
      if (!this.checkType.toString()) {
        console.log(this.checkType);
        this.$message("请选择商品配送方式");
        return;
      }
      let data = {
        barCode: this.barCode,
        categoryId: this.type,
        content: this.content,
        costPrice: gardenCostPrice,
        employeePrice: gardenPri ? gardenPri : prices,
        oldPrice: gardenOldPrice,
        goodName: this.goodsName,
        goodLogos: newImages,
        logo: newImages[0] ? newImages[0] : "",
        maxSale: this.limit,
        mchId: this.chooseCompany.id,
        price: prices,
        status: this.status,
        // stock: this.stacks,
        saleDesc: this.saleDesc,
        stockType: this.stockType,
        unit: this.specification,
        weight: this.weight,
        origin: this.product,
        lifeTime: this.liftTime,
        type: this.type,
        goodId: this.goodId,
        warningRepertory: this.warningRepertory,
        deliveryType: this.checkType.toString(),
      };
      console.log(data);
      if (this.status == -1) {
        let newDate = {
          endTime: new Date(this.etime).getTime(),
          goodId: this.goodId,
          minCount: this.minCount,
          presaleMark: this.mark,
          presalePrice: this.presalePrice * 100,
          sendTime: this.preRedio == "0" ? this.date1 : this.date2,
          sendType: this.preRedio !== "0" ? "3" : this.sendType,
        };
        Object.assign(data, newDate);
        console.log(data);
        exitPreGoods(data).then((res) => {
          console.log(res);
          this.$message("商品属性修改成功");
          if (res.data == "SUCCESS") {
            this.$router.push({
              path: "/main/preSellList",
            });
          }
        });
      } else if (this.status == 1) {
        if (this.propertyName == "") {
          this.$message("请填写本商品属性");
          return;
        }
        this.relatedGoods.forEach((item) => {
          if (item.name == "") {
            this.$message("请填写关联商品属性");
            throw new Error("报错打断");
          } else if (typeof item.id == "undefined") {
            this.$message("有属性未关联商品");
            throw new Error("报错打断");
          }
        });
        data.linkDesc = this.propertyName;
        data.linkGoodsDesc = [];
        data.linkGoodsIds = [];
        this.relatedGoods.forEach((item) => {
          data.linkGoodsDesc.push(item.name);
          data.linkGoodsIds.push(item.id);
        });
        exitGoods(data).then((res) => {
          console.log(res);
          if (res.data == "SUCCESS") {
            this.$router.push({
              path: "/main/storeDown",
            });
          }
        });
      } else {
        if (this.propertyName == "") {
          this.$message("请填写本商品属性");
          return;
        }
        this.relatedGoods.forEach((item) => {
          if (item.name == "") {
            this.$message("请填写关联商品属性");
            throw new Error("报错打断");
          } else if (typeof item.id == "undefined") {
            this.$message("有属性未关联商品");
            throw new Error("报错打断");
          }
        });
        data.linkDesc = this.propertyName;
        data.linkGoodsDesc = [];
        data.linkGoodsIds = [];
        this.relatedGoods.forEach((item) => {
          data.linkGoodsDesc.push(item.name);
          data.linkGoodsIds.push(item.id);
        });
        exitGoods(data).then((res) => {
          console.log(res);
          if (res.data == "SUCCESS") {
            this.$router.push({
              path: "/main/storeUp",
            });
          }
        });
      }
    },
    // 删除上传主图
    delImages(index) {
      this.imagesList.splice(index, 1);
      // console.log(this.imagesList);
    },
    // 分转元
    regFenToYuan(fen) {
      var num = fen;
      num = fen * 0.01;
      num += "";
      var reg =
        num.indexOf(".") > -1
          ? /(\d{1,3})(?=(?:\d{3})+\.)/g
          : /(\d{1,3})(?=(?:\d{3})+$)/g;
      num = num.replace(reg, "$1");
      num = this.toDecimal2(num);
      return num;
    },
    toDecimal2(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    },
    // 排序
    order(words) {
      var correlation = [],
        reorder = [];
      if (words === "") {
        return words;
      }
      words.forEach((item, index) => {
        let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let src = item.match(srcReg);
        correlation[index] = {};
        correlation[index]["i"] = index;
        let number = "";
        let newStr = src[1];
        if (newStr.indexOf("/") > 0) {
          //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
          let filename = "";
          filename = newStr.substring(
            newStr.lastIndexOf("/") + 1,
            newStr.length
          );
          number = filename.substring(0, filename.indexOf("."));
        }
        correlation[index]["v"] = Number(number);
      });
      correlation.sort((a, b) => {
        return a.v - b.v;
      });
      correlation.forEach((item, index) => {
        reorder.push(words[item.i]);
      });
      return reorder.join("");
    },
    // 排序
    order2(words) {
      var correlation = [],
        reorder = [];
      if (words === "") {
        return words;
      }
      words.forEach((item, index) => {
        correlation[index] = {};
        correlation[index]["i"] = index;
        let number = "";
        if (item.indexOf("/") > 0) {
          //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
          let filename = "";
          filename = item.substring(item.lastIndexOf("/") + 1, item.length);
          number = filename.substring(0, filename.indexOf("."));
        }
        correlation[index]["v"] = Number(number);
      });
      correlation.sort((a, b) => {
        return a.v - b.v;
      });
      correlation.forEach((item, index) => {
        reorder.push(words[item.i]);
      });
      return reorder;
    },
    // 监听图片数组ID
    getImageFileId(introduce) {
      let totalStr = introduce; // introduce 是html代码
      let imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
      let arr = totalStr.match(imgReg); // 筛选出所有的img
      // console.log('arr', arr);
      // let srcArr = [];
      // if (arr !== null) {
      //   for (let i = 0; i < arr.length; i++) {
      //     let src = arr[i].match(srcReg);
      //     // 获取图片地址
      //     srcArr.push(src[1]);
      //   }
      // }
      return arr;
    },
    handleCheckedCitiesChange(id) {
      if (this.checkList.length > 1) {
        this.checkList.splice(0, 1);
      }
      let [status] = this.checkList;
      this.status = status;
      console.log(this.checkList);
    },
    handleCheckedTypesChange(id) {
      // if(this.checkType.length > 1){
      //   this.checkType.splice(0,1)
      // }
      this.checkType = this.checkType;
      console.log(this.checkType);
      // let [status] = this.checkType;
      // this.selectType = status;
      // console.log(this.selectType)
    },
    changeRedio(e) {
      this.preRedio = e;
      this.sendType = "";
      if (this.preRedio == 0) {
        this.date2 = "";
      } else {
        this.date1 = "";
      }
    },
    getDateString(stamp) {
      let d = new Date(parseInt(stamp));
      let month =
        d.getMonth() + 1 < 10 ? 0 + "" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? 0 + "" + d.getDate() : d.getDate();
      let hour = d.getHours() < 10 ? 0 + "" + d.getHours() : d.getHours();
      let minute =
        d.getMinutes() < 10 ? 0 + "" + d.getMinutes() : d.getMinutes();
      let second =
        d.getSeconds() < 10 ? 0 + "" + d.getSeconds() : d.getSeconds();
      let dateString =
        d.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minute;
      return dateString;
    },
    addRelated() {
      //添加关联商品
      this.relatedGoods.push({ name: "", goodName: "" });
    },
    delRelated(i) {
      this.relatedGoods.splice(i, 1);
    },
    selectProducts(i) {
      this.selectIndex = i;
      this.centerDialogVisible = true;
      this.getGoodList();
    },
    getGoodList(page) {
      let mchId = this.chooseCompany.id;
      let data = {
        pageCount: 10,
        page: this.currentPage,
        goodName: this.searchValue,
        mchId: mchId,
      };
      if (page) {
        console.log(1);
        data.page = page;
      }
      getSeckillGood(data).then((res) => {
        let count = res.data.pop();
        if (typeof count != "undefined") {
          this.goodsCount = count.goodsCount;
        }
        this.tableData = res.data;
      });
    },
    reset() {
      this.searchValue = "";
      this.getGoodList();
    },
    addsgood(data) {
      let show = true;
      this.relatedGoods.forEach((item) => {
        if (item.id == data.goodId) {
          show = false;
        }
      });
      if (show) {
        this.relatedGoods[this.selectIndex].goodName = data.goodName;
        this.relatedGoods[this.selectIndex].id = data.goodId;
        console.log(this.relatedGoods);
        this.goodShow = true;
        this.centerDialogVisible = false;
      } else {
        this.$message("该商品已绑定");
      }
    },
    getValue(data) {
      this.dialogVisible = false;
      this.relatedGoods.push({
        name: "",
        goodName: data.goodsName,
        id: data.id,
      });
      console.log(this.relatedGoods);
    },
    pageFn() {
      this.getGoodList();
    },
  },
};
</script>

<style lang="scss" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#addStore {
  width: 100%;
  padding: 0px 5px 5px 26px;
  box-sizing: border-box;
  .top {
    border-bottom: 1px solid #ebf1f3;
    height: 75px;
    i {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .msgTitle {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .button {
      float: right;
    }
  }
  .containertMain {
    // padding: 11px 83px 24px 78px;
    box-sizing: border-box;
    .Modular1 {
      .title {
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        padding-left: 39px;

        .title_ {
          font-size: 14px;
          color: gray;
          margin-left: 10px;
        }
      }
      .content {
        padding: 11px 83px 24px 78px;
        .upload {
          /deep/ .el-form-item__content {
            display: flex;
            .imagesList {
              display: flex;
              margin: 0;
              padding-left: 0;
              .imagesItem {
                list-style-type: none;
                padding-right: 20px;
                position: relative;
                .img {
                  width: 85px;
                  height: 85px;
                  // border: 1px solid #f0f0f0;
                }
                .del {
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: -10px;
                  right: 10px;
                }
              }
            }
          }
        }
      }
      // background: #999;
    }
    .Modular2 {
      margin-top: 20px;
      .title {
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        padding-left: 39px;
      }
      .content {
        padding: 11px 83px 24px 78px;
      }
      .uploadimg {
        display: inline-block;
        text-align: center;
        line-height: 40px;
        padding: 5px 10px;
        cursor: pointer;
        color: #ccc;
        // margin-bottom: 8px;
      }

      // background: #999;
    }
  }
  .topleft {
    float: left;
    width: 100%;
    height: 100%;
    margin: 50px;
  }
  .text {
    display: inline-block;
    font-size: 32px;
    margin-left: 10px;
  }
  .inputItem {
    width: 100%;
  }
  .inputItem30 {
    width: 30%;
  }
  .inputItem70 {
    width: 160px;
  }
  .inputItem80 {
    width: 130px;
  }
  .picture {
    width: 85px;
    height: 85px;
    border: 1px solid #f0f0f0;
    padding: 20px;
    box-sizing: border-box;
  }
  .w-e-toolbar {
    border: 1px solid #dcdfe6;
  }
  .w-e-text-container {
    height: 300px !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
    border: 1px solid #dcdfe6;
    border-top: none;
    z-index: 99 !important;
  }
  .imgClass {
    display: block;
    max-width: 50%;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .presellSet {
    .set {
      font-size: 14px;
      color: #606266;
      margin-bottom: 20px;
    }
    .blex1 {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #606266;
    }
    .blex2 {
      display: flex;
      align-items: center;
      margin-top: 20px;
      font-size: 14px;
      color: #606266;
    }
    .num {
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      margin-left: 5px;
    }
    .endNum {
      font-size: 14px;
      color: #606266;
    }
  }
  .check {
    padding-bottom: 20px;
  }
  .textColor {
    color: #ccc;
  }
}
/deep/.w-e-toolbar .w-e-menu {
  z-index: 99 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/edit.vue